module.exports = {
    methods: {
        /**
         * Translate the given key.
         */
        __(key, replace = {}) {
            //debugger;
            translation = this.getTranslatedString(key);
            translation = this.replacePlaceholders(translation, replace);

            return translation
        },

        /**
         * Translate the given key with basic pluralization.
         */
        __n(key, number, replace = {}) {
            let options = this.getTranslatedString(key).split('|');

            let translation = ''
            if(options[0].charAt(0) != '{' && options[0].charAt(0) != '[') {
                translation = options[1];

                if(number == 0) {
                    translation = options[0];
                }
            } else {
                translation = '';
                let arrayLength = options.length;
                for(let i = 0 ; i < arrayLength; i++) {
                    let val = options[i];
                    let qtyExpression = val.substr(0,val.indexOf(' '));
                    if(this.checkQuantity(qtyExpression, number)) {
                        translation = val.substr(val.indexOf(' ')+1);
                    }
                }
            }
            translation = translation.replace(':count', number)

            return this.replacePlaceholders(translation, replace);
        },

        getTranslatedString: function(key) {
            let key_list = key.split(".");
            let translation = "";
            for (let index = 0; index < key_list.length; index++) {
                let current_key = key_list[index];
                let source = (index==0)?this.$page.language:translation;
                translation = source[current_key]? source[current_key]: key
            }
            return translation;
        },

        replacePlaceholders: function (translation, replace) {
            Object.keys(replace).forEach(function (key) {
                translation = translation.replace(':' + key, replace[key])
                translation = translation.replace(':' + key.toUpperCase(), replace[key].toUpperCase())
                translation = translation.replace(':' + key.toProperCase(), replace[key].toProperCase())
            });
            return translation;
        },

        checkQuantity: function(expr, qty) {
            if(expr.includes("{")) {
                let target = parseInt(expr.substring(expr.indexOf("{") + 1,expr.lastIndexOf("}")));
                if(qty==target) {
                    return true;
                }
            } else if(expr.includes("[")) {
                let range = expr.substring(expr.indexOf("[") + 1,expr.lastIndexOf("]")).split(",");
                if(range[1]=="*" && qty >= parseInt(range[0])) {
                    return true;
                } else {
                    if(qty >= parseInt(range[0]) && qty <= parseInt(range[1])) {
                        return true;
                    }
                }
            }
            return false;
        }
    },
}

String.prototype.toProperCase = function () {
    return this.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
};
